import { useMutation } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { PortfolioExitStrategyPositions } from 'services/apiServices';
import {
  PostBotExitStrategyPositionsResult,
  Errors,
} from 'types/ApiServicesTypes';

export default function usePortfolioExitStrategyPositions(id: number) {
  const { showAlert } = useContext(ToastContext);
  const mutation = useMutation<
    PostBotExitStrategyPositionsResult,
    Errors,
    { positionIds: number[] }
  >(['PortfolioExitStrategyPositions', id], values =>
    PortfolioExitStrategyPositions(id, values.positionIds)
      .then(res => {
        if (res.error) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          showAlert!(res.error);
        }
        return res;
      })
      .catch(err => {
        showAlert!(err.message as string);
        return err;
      }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
}
